<style lang="scss" scoped>
.title-wrapper-content{
  background: url('./../assets/img/group15copy5.svg') no-repeat;
  background-size: contain;
  height: 94px;
  width: 536px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  span{
    font-size:30px;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:42px;
  }
}
</style>

<template>
  <div class="title-wrapper-content">
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Title.vue